module.exports = __webpack_public_path__ + "img/pagePersonalization.748a631d.svg";